if (!customElements.get('lets-get-real-value')) {
  customElements.define('lets-get-real-value',class extends HTMLElement {
    connectedCallback() { this.frame=requestAnimationFrame(()=>this.init()); }
    init() {
      if (!this.isConnected || this.controller) return;
      this.controller=new AbortController();
      this.motion=matchMedia('(prefers-reduced-motion: reduce)');
      this.counters=[...this.querySelectorAll('[data-value]')];
      this.classList.add('is-ready');
      const finish=()=>{clearTimeout(this.timer);cancelAnimationFrame(this.countFrame);this.counters.forEach(el=>el.textContent=`${el.dataset.value}%`);};
      this.motion.addEventListener('change',()=>{if(this.motion.matches) finish();},{signal:this.controller.signal});
      this.observer=new IntersectionObserver(entries=>{
        if(!entries.some(entry=>entry.isIntersecting)) return;
        this.classList.add('is-in'); this.observer.disconnect();
        if(this.motion.matches) { finish(); return; }
        // Count alongside the answer reveal rather than while it is hidden.
        this.timer=setTimeout(()=>{
          const start=performance.now();
          const step=now=>{
            const p=Math.min(1,(now-start)/1300);
            this.counters.forEach(el=>el.textContent=`${Math.round(Number(el.dataset.value)*(1-Math.pow(1-p,3)))}%`);
            if(p<1) this.countFrame=requestAnimationFrame(step);
          };
          this.countFrame=requestAnimationFrame(step);
        },1500);
      },{rootMargin:'0px 0px -12% 0px'});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);cancelAnimationFrame(this.countFrame);clearTimeout(this.timer);
      this.controller?.abort();this.controller=null;this.observer?.disconnect();
      this.counters?.forEach(el=>el.textContent=`${el.dataset.value}%`);
      this.classList.remove('is-ready','is-in');
    }
  });
}